import React, {useState} from 'react';
//import { useNavigate } from "react-router-dom";
//import { useDispatch } from "react-redux";
import {Trans,  useTranslation } from 'react-i18next';
import {navigateTo} from "../../Helper"
import CheckBox from './CheckBox';

const Specialization = ({ specialization, changeSpecialization, errors }) => {
    //const dispatch = useDispatch();
    //const navigate = useNavigate();
    const { t } = useTranslation();

    const handleClick = (subcategory) => {
        //navigateTo(dispatch, navigate, `/providers/${subcategory}`);
    }; 

    const toggleClick = (e) =>{

    }

    return <div className='mt20 specialization'>
        <div className='mt30'>
            <div className='center-div font-25 font-bold text-align-center'>{t("specialization")}</div>
        </div>


        {errors.specialization && <div className='mt5 error font-12'><Trans i18nKey={errors.specialization} /></div>}
        <div className='mt30'>
            <div className='font-15'>{t("select_options")}</div>
        </div>
        <div className='mt30'>
            <div className='font-30 font-bold color-550952'>{t("edit_provider")}</div>
        </div>

        <div className='mt10'><CheckBox id='beta_readers' text={t('beta_readers')} value={specialization?.beta_readers} onChange={(id) => changeSpecialization(id)} /></div>

        <SubCategories specialization={specialization} changeSpecialization={(id) => changeSpecialization(id)} title={"expert_editing_services"} subCategories={['expert_editor_feedback', 'exprert_editor_writing_support', 'idea_development']}></SubCategories>
        <SubCategories specialization={specialization} changeSpecialization={(id) => changeSpecialization(id)} title={'editing_services'} subCategories={['content_editing', 'technical_editing', 'proofreading']}></SubCategories>
        <SubCategories specialization={specialization} changeSpecialization={(id) => changeSpecialization(id)} title={'translation_services'} subCategories={['hebrew_to_english', 'english_to_hebrew', 'other_languages']}></SubCategories>

        <div className='mt30'>
            <div className='font-30 font-bold  color-550952'>{t("graphic_provider")}</div>
        </div>

        <SubCategories specialization={specialization} changeSpecialization={(id) => changeSpecialization(id)} title={"logo_and_branding"} subCategories={['logo_design_for_the_writer', 'website_design_for_the_writer', 'book_branding']}></SubCategories>
        <SubCategories specialization={specialization} changeSpecialization={(id) => changeSpecialization(id)} title={"packaging_and_covers"} subCategories={['cover_design', 'typesetting', 'packages_and_labels_design']}></SubCategories>
        <SubCategories specialization={specialization} changeSpecialization={(id) => changeSpecialization(id)} title={'illustration_and_art'} subCategories={['books_illustration', 'comics_and_children_illustration', 'ai_art']}></SubCategories>
        <SubCategories specialization={specialization} changeSpecialization={(id) => changeSpecialization(id)} title={'design_and_printing'} subCategories={['bookmark_design', 'postcard_design', 'ai_art_dp']}></SubCategories>

        <div className='mt30'>
            <div className='font-30 font-bold color-550952'>{t("marketing_provider")}</div>
        </div>

        <SubCategories specialization={specialization} changeSpecialization={(id) => changeSpecialization(id)} title={"social_media"} subCategories={['social_media_marketing', 'influencers_marketing', 'community_management']}></SubCategories>
        <SubCategories specialization={specialization} changeSpecialization={(id) => changeSpecialization(id)} title={"analytics_and_strategy"} subCategories={['marketing_strategy', 'marketing_consulting', 'market_analysis']}></SubCategories>
        <SubCategories specialization={specialization} changeSpecialization={(id) => changeSpecialization(id)} title={'methods_and_techniques'} subCategories={['advertisement', 'video_marketing', 'pr']}></SubCategories>

        <div className='mt30'>
            <div className='font-30 font-bold color-550952'>{t("print_provider")}</div>
        </div>

        <SubCategories specialization={specialization} changeSpecialization={(id) => changeSpecialization(id)} title={"printing_agencies"} subCategories={['northen_area', 'central_area', 'southen_area']}></SubCategories>

    </div>;
};

export default Specialization;


const SubCategories = ({ specialization, changeSpecialization, title, subCategories }) => {

    const [state, setState] = useState({open:false});

    const { t } = useTranslation();

    const toggleClick = (e) =>{
        setState({
            ...state,
            open: !state.open
        });
    }

    return <div className='mt20 subcategories'>
        <div className='mt20'><div className='shadow-button specialization-button' onClick={(e) => toggleClick(e)}> 
            <div>{t(title)} </div>
            <img src={state.open?'/images/close.png':'images/open.png'} className='subcategories-open-close-icon' alt=''/>
        </div></div>
        {state.open && <div>
            {subCategories && subCategories.map((subCategory, index) => (
                <div key={index} className='mt15'><CheckBox id={subCategory} text={t(subCategory)} value={specialization[subCategory]} onChange={(id) => changeSpecialization(id)} /></div>
             ))}
        </div>}


    </div>;
};
